<template>
  <main id="main">
    <!-- movie_pop -->
    <div id="movie_pop">
      <a href="#none" onclick="closeLayer('movie_pop')" class="btn_close">창닫기</a>
      <div class="box">
        <div class="mbox">
          <iframe width="560" height="315" src="https://www.youtube.com/embed/ZMDNu0K20kk" frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
    </div>
    <!-- e : movie_pop -->

    <div v-for="banner in banners" :key="banner.id">
      <section v-if="banner.id === 1"
               class="video-section">
        <video-player :options="videoOptions" />
        <div class="tbox" data-aos="fade-up">
          <p class="t01" :style="{color: banner.textColor}" v-html="banners[0].title" />
          <p class="t02" :style="{color: banner.textColor}" v-html="banners[0].description" />
        </div>
      </section>
      <section v-else class="msection">
        <div class="tbox" data-aos="fade-up">
          <p class="t01" :style="{color: banner.textColor}" v-html="banner.title" />
          <p class="t02" :style="{color: banner.textColor}" v-html="banner.description" />
          <template v-if="banner.linkVisible && banner.linkUrl">
            <a v-if="banner.linkUrl.startsWith('http')" :href="banner.linkUrl" target="_blank"
               class="more"
               :class="{'fc_white' : banner.textColor.toLowerCase() === '#ffffff'}"
               :style="{color: banner.textColor, border: `solid 2px ${banner.textColor}`}">
              <span>{{banner.linkText}}</span>
            </a>
            <router-link v-else :to="{path: banner.linkUrl}" class="more"
                         :class="{'fc_white' : banner.textColor.toLowerCase() === '#ffffff'}"
                         :style="{color: banner.textColor, border: `solid 2px ${banner.textColor}`}">
              <span>{{banner.linkText}}</span>
            </router-link>
          </template>
        </div>
        <div class="bg" v-if="windowSize.width < 768"
             v-lazy-background-image
             :style="{backgroundImage: `url(${publicPath}upload/main_banner/${banner.img2})`}">
        </div>
        <div class="bg" v-else
             v-lazy-background-image
             :style="{backgroundImage: `url(${publicPath}upload/main_banner/${banner.img1})`}">
        </div>
      </section>
    </div>

    <modal
      v-for="popup in popupList"
      :key="`popup-${popup.id}`"
      :name="`popup-${popup.id}`"
      :width="popup.width"
      height="auto"
      :pivotX="0"
      :pivotY="0"
      :click-to-close="false">
      <button type="button" class="close" @click="closePopup(popup.id)"
              style="position: absolute; top: 10px; right: 10px; ">
        <span aria-hidden="true">×</span>
      </button>
      <template v-if="popup.linkStatus">
        <a v-if="popup.link.startsWith('http')" :href="popup.link" target="_blank">
          <img v-lazy="`${publicPath}upload/popup/${popup.img}`" />
        </a>
        <router-link v-else :to="{path: popup.link}">
          <img v-lazy="`${publicPath}upload/popup/${popup.img}`" />
        </router-link>
      </template>
      <img v-else v-lazy="`${publicPath}upload/popup/${popup.img}`" />
      <div class="d-flex justify-content-end">
        <span style="cursor:pointer;font-size: 12px; margin: 4px;" @click="closePopup(popup.id, true)">오늘 하루 열지 않음</span>
      </div>
    </modal>
  </main>
</template>

<script>
import VideoPlayer from '@/components/VideoPlayer.vue';

export default {
  name: 'home',
  components: { VideoPlayer },
  data() {
    return {
      popupList: [],
      banners: [],
      windowSize: {
        width: 0,
        height: 0,
      },
      videoOptions: {
        playsinline: true,
        autoplay: true,
        controls: false,
        loop: true,
        muted: true,
        // preload: 'auto',
        sources: [
          {
            src: `${this.publicPath}movie_20191230.mp4?${this.moment().format('x')}`,
            type: 'video/mp4',
          },
        ],
      },
    };
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted() {
    this.axios.get('/api/banner')
      .then(({ data }) => {
        this.banners = data;
      });

    this.$axios.get('/api/popup')
      .then(({ data }) => {
        this.popupList = data;

        this.$nextTick(() => {
          setTimeout(this.showPopup, 1000);
        });
      });
  },
  methods: {
    handleResize() {
      this.windowSize.width = window.innerWidth;
      this.windowSize.height = window.innerHeight;
    },

    showPopup() {
      this.popupList.forEach((popup) => {
        console.log('show popup ', popup.id);
        if (!this.$cookies.isKey(`popup-${popup.id}`)) {
          this.$modal.show(`popup-${popup.id}`);
        }
      });
    },
    closePopup(id, doNotOpenToday = false) {
      if (doNotOpenToday) {
        this.$cookies.set(`popup-${id}`, true, '1d');
      }

      this.$modal.hide(`popup-${id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
  .video-section {
    position: relative;
    overflow: hidden;
    /*padding-top: 135px;*/
    text-align: center;
    line-height: 1.5em;
    background-color: #fafafa;
    box-sizing: border-box;
    width: 100%;

    .tbox {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      padding-top: 135px;

      .t01 {
        font-size: 66px;
        color: #0c1e2b;
        font-weight: 700;
        line-height: 1.25em;
        word-break: keep-all;
      }

      .t02 {
        font-size: 32px;
        margin-top: 15px;
        padding: 0 15px;
        color: #0c1e2b;
        font-weight: 500;
        line-height: 1.35em;
      }
    }
  }

  .v--modal-overlay {
    background: transparent;
    top: 130px;
    width: auto;
    height: auto;
  }

  @media all and (max-width: 768px) {
    .video-section {
      .tbox {
        padding-top: 40px;

        .t01 {
          font-size: 34px;
        }

        .t02 {
          font-size: 17px;
        }
      }
    }

    .v--modal-overlay {
      top: 50px;
    }
  }


</style>
